/*******************************************************************************
 * $Id: BooksTools.js 21479 2022-11-12 00:51:12Z sthames $ */
/**
 * @ngdoc    service
 * @module   books.util
 * @name     books.util.service:BooksTools
 * @requires csm.ui.alert
 * @requires csm.ui.ImageLoaderPanel
 * @requires csm.text.TemplateTextBuilder
 * @requires SERVER
 *
 * @description
 *   General tools for use in Books DB apps.
 *******************************************************************************/
/* @ngInject */
export function booksToolsFactory(
  SERVER,
  Alert,
  ImageLoaderPanel,
  TemplateTextBuilder
) {
  return {
    /***************************************************************************
     * showImageLoaderPanel */
    /**
     * @ngdoc    method
     * @name     showImageLoaderPanel
     * @methodOf books.util.service:BooksTools
     * @description
     * Shows the ImageLoaderPanel for the user image **`type`** and sends image
     * file commands to server handler **`ImageLoader.aspx`**. If an error occurs
     * on the server, a fatal error notification is generated for a few seconds
     * and the dialog closes.
     *
     * @param {string}  type
     *   User image type from **`csm.booksdb.BooksDBConstants.UIT_??????`**.
     *
     * @param {object}  values
     *   Field values to apply to image URL template.
     *
     * @param {string=} title
     *  Dialog title. Default="Image Loader"
     *
     * @param {function=} listener
     *  Function called whenever a change is made to the target image. This can be used
     *  to reload the image after it has been updated.
     *
     * @returns {Promise}
     *  Resolved when user closes the dialog or a server error occurs. **`result`** is
     *  **`true`** if a new image was uploaded. If an error occurs, a fatal error
     *  notification is generated for a few seconds and **`result`** is undefined.
     ***************************************************************************/
    showImageLoaderPanel: function (type, values, title, listener) {
      var serviceURL = 'ImageLoader.aspx';
      var imageURL = new TemplateTextBuilder(
        SERVER.userImages[type].path,
        values
      ).toString();
      var boxDim = {
        width: SERVER.userImages[type].width,
        height: SERVER.userImages[type].height
      };
      var formData = { type: type, values: values };
      var result = ImageLoaderPanel.show(
        serviceURL,
        imageURL,
        boxDim,
        title,
        formData,
        listener
      ).then(
        function (newImageLoaded) {
          return Promise.resolve(newImageLoaded);
        },
        // TODO: PK We should handle this error more gracefully
        function (error) {
          Alert.error(
            'A problem occured on the server.\nPlease try again.',
            'Server Error'
          );
          return Promise.resolve();
        }
      );
      return result;
    }
  };
}
